import { render } from "./gverbmodule.vue?vue&type=template&id=68a5ac8e&scoped=true"
import script from "./gverbmodule.vue?vue&type=script&lang=js"
export * from "./gverbmodule.vue?vue&type=script&lang=js"

import "./gverbmodule.vue?vue&type=style&index=0&id=68a5ac8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a5ac8e"]])

export default __exports__